import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import image from './emptystate_goals.png'

export const EmptyState: React.FC<{
  onClick: () => void
}> = ({ onClick }) => {
  return (
    <Box gap="s32" alignItems="center" textAlign="center">
      <img src={image} />
      <Box gap="s24" alignItems="center">
        <Box gap="s8" maxWidth="s400">
          <Text.Header2>{i18n.t('performance_cycles.empty_state_banner_cta')}</Text.Header2>
          <Text.Normal>{i18n.t('performance_cycles.empty_state_banner')}</Text.Normal>
        </Box>
        <Button iconName="add" onClick={() => onClick()}>
          {i18n.t('performance_cycles.new_cycle')}
        </Button>
      </Box>
    </Box>
  )
}
